import React from 'react'
import { useParams } from 'react-router-dom'
import EmployeeAttendanceList from '../components/EmployeeAttendanceList';
import EmployeeLeaveRequestList from '../components/EmployeeLeaveRequestList';
import HRMSLayout from '../../../../../layout/components/HRMSLayout';

function EmployeeAttendancePage() {
    const {id} = useParams();
  return (
    <HRMSLayout>
        <div className='row'>
            <div className='col-md-6'>
                <EmployeeAttendanceList employeeId={id} />
            </div>
            <div className='col-md-6'>
                <EmployeeLeaveRequestList employeeId={id} />
            </div>
        </div>
    </HRMSLayout>
  )
}

export default EmployeeAttendancePage